import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import RecalProcessAndGenSubmitEditPanel from "./RecalProcessAndGenSubmitEditPanel";
import RecalProcessAndGenSubmitPanel from "./RecalProcessAndGenSubmitPanel";

const RecalProcessAndGenGenerateRightPanel = () => {
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const { isShowSubmitEditPanel } = recalProcessAndGenState;

    return <>
        <div className={`main-comp-wrapper${(isShowSubmitEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowSubmitEditPanel ? "60%" : "100%"}
                rightSectionWidth={isShowSubmitEditPanel ? "40%" : "0%"}
                leftChildren={<RecalProcessAndGenSubmitPanel />}
                rightChildren={<RecalProcessAndGenSubmitEditPanel />}
            />
        </div>
    </>
}

export default RecalProcessAndGenGenerateRightPanel;
